<template>
  <div>
    <a-modal
      :visible="visible"
      title="编辑"
      :confirmLoading="confirmLoading"
      :destroyOnClose="true"
      :maskClosable="false"
      @cancel="handleCancel"
      @ok="handleConfirm"
    >
      <a-form :form="dataForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="账号数量">
          <a-input-number
            v-decorator="[
              'user_count',
              {
                initialValue: item.user_count,
                rules: [{ required: true, message: '请输入账号数量' }],
              },
            ]"
            style="width: 100%"
          />
        </a-form-item>

        <a-form-item label="续费周期">
          <a-select :allowClear="true" style="width: 100%" @change="onChangeRenewalPeriod">
            <a-select-option key="按月" value="按月">按月</a-select-option>
            <a-select-option key="按季度" value="按季度">按季度</a-select-option>
            <a-select-option key="按年" value="按年">按年</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="到期日期">
          <a-date-picker
            v-decorator="[
              'expiry_date',
              {
                initialValue: item.expiry_date,
                rules: [{ required: true, message: '请输入到期日期' }],
              },
            ]"
            valueFormat="YYYY-MM-DD"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item label="激活状态">
          <a-select v-decorator="['is_active', { initialValue: item.is_active ? 'T' : 'F' }]" style="width: 100%">
            <a-select-option key="T" value="T">激活</a-select-option>
            <a-select-option key="F" value="F">冻结</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { accountUpdate } from "@/apis/data";
import moment from "moment";

export default {
  props: ["visible", "item"],
  model: { prop: "visible", event: "cancel" },
  data() {
    return {
      confirmLoading: false,
      dataForm: null,
    };
  },
  methods: {
    handleConfirm() {
      this.dataForm.validateFields((error, values) => {
        if (error === null) {
          this.confirmLoading = true;
          accountUpdate({ ...this.item, ...values })
            .then((data) => {
              this.$emit("update", data);
              this.$message.success("编辑成功");
              this.handleCancel();
            })
            .catch((error) => {
              const errorFields = Object.entries(error).reduce((acc, [field, errors]) => {
                acc[field] = { value: values[field], errors: errors.map((value) => new Error(value)) };
                return acc;
              }, {});
              this.dataForm.setFields(errorFields);
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    },
    handleCancel() {
      this.$emit("cancel", false);
    },
    onChangeRenewalPeriod(value) {
      if (value === "按月") {
        this.dataForm.setFieldsValue({
          expiry_date: moment(this.item.expiry_date).add(30, "days").format("YYYY-MM-DD"),
        });
      } else if (value === "按季度") {
        this.dataForm.setFieldsValue({
          expiry_date: moment(this.item.expiry_date).add(90, "days").format("YYYY-MM-DD"),
        });
      } else if (value === "按年") {
        this.dataForm.setFieldsValue({
          expiry_date: moment(this.item.expiry_date).add(365, "days").format("YYYY-MM-DD"),
        });
      }
    },
  },
  mounted() {
    this.dataForm = this.$form.createForm(this);
  },
};
</script>

<style scoped></style>
